import useApi from '../../../services/useApi'

export const useGetSupplierDropdown = () => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/profitability/filters/suppliers'
  )

  return {
    suppliers: response?.data || [],
    isLoading: isFetching,
  }
}
